import React from "react";
import { Trans } from "@lingui/react/macro";
import { FaSpinner } from "react-icons/fa";

const WorkEntryDisplay = ({
    userWorkEntry,
    files,
    formatTime,
    isImage,
    handleEdit,
    handleDelete,
    selectedDate,
    handleDateChange,
}) => {
    return (
        <div className="work-entries-section">
            <h2 className="work-header">
                <Trans>Your Delivery Note for</Trans>{" "}
                <input
                    type="date"
                    value={selectedDate}
                    onChange={handleDateChange}
                    className="date-selector-inline"
                />
            </h2>
            <div className="work-entry">
                <p>
                    <strong><Trans>Preparation time in warehouse:</Trans></strong> {formatTime(userWorkEntry.preparation_hours)}
                </p>
                <p>
                    <strong><Trans>Transport Time:</Trans></strong> {formatTime(userWorkEntry.transport_time)}
                </p>
                <p>
                    <strong><Trans>Work start time:</Trans></strong> {userWorkEntry.start_time}
                </p>
                <p>
                    <strong><Trans>Total break time:</Trans></strong> {formatTime(userWorkEntry.total_break)}
                </p>
                <p>
                    <strong><Trans>Work end time:</Trans></strong> {userWorkEntry.end_time}
                </p>
                <p>
                    <strong><Trans>Time in warehouse after work:</Trans></strong> {formatTime(userWorkEntry.after_magazine_hours)}
                </p>
                <p>
                    <strong><Trans>Used materials:</Trans></strong> {userWorkEntry.materials}
                </p>
                {/* 27/10/2026 (Bartel): gestructureerde materialen als lijst. */}
                {(userWorkEntry.materialen || []).length > 0 && (
                    <table className="materialen-tabel">
                        <thead>
                            <tr>
                                <th><Trans>Description</Trans></th>
                                <th><Trans>Quantity</Trans></th>
                                <th><Trans>Unit</Trans></th>
                            </tr>
                        </thead>
                        <tbody>
                            {userWorkEntry.materialen.map((m) => (
                                <tr key={m.id}>
                                    <td>{m.omschrijving}</td>
                                    <td>{m.aantal ?? ""}</td>
                                    <td>{m.eenheid}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                <p>
                    <strong><Trans>Work Description:</Trans></strong> {userWorkEntry.description_work}
                </p>
                <p>
                    <strong><Trans>Project Finished:</Trans></strong> {userWorkEntry.finished ? <Trans>Yes</Trans> : <Trans>No</Trans>}
                </p>
                <div className="photo-gallery">
                    {/* Non-image files */}
                    <h4><Trans>Files:</Trans>{files.length === 0 && <FaSpinner className="loading-icon" />}</h4>
                    <ul className="non-image-files">
                        {files
                            .filter(file => !isImage(file))
                            .map((file, index) => {
                                const isBase64 = typeof file === "object" && file.content; // Check if file is from backend
                                const href = isBase64
                                    ? `data:application/octet-stream;base64,${file.content}`
                                    : URL.createObjectURL(file);
                                return (
                                    <li key={index} className="file-item">
                                    <a
                                        href={href}
                                        download={file.name || `File_${index + 1}`}
                                        className="file-link"
                                    >
                                        {file.name || `File ${index + 1}`}
                                    </a>
                                    </li>
                                );
                            })}
                    </ul>

                    {/* Image files */}
                    <h4><Trans>Images:</Trans>{files.length === 0 && <FaSpinner className="loading-icon" />}</h4>
                    <div className="image-previews">
                        {files
                            .filter(file => isImage(file))
                            .map((photo, index) => {
                                const isBase64 = typeof photo === "object" && photo.content; // Check if the photo is from backend
                                const src = isBase64
                                    ? `data:image/jpeg;base64,${photo.content}` // Base64 content from backend
                                    : URL.createObjectURL(photo); // File object for newly uploaded photos

                                return (
                                    <div key={index} className="image-container">
                                        <img
                                            src={src}
                                            alt={`preview-${index}`}
                                            className="photo"
                                        />
                                    </div>
                                );
                            })}
                    </div>
                </div>
                
                <div className="work-entry-actions">
                    <button onClick={() => handleEdit()} className="edit-button">
                        <Trans>Edit</Trans>
                    </button>
                    <button onClick={() => handleDelete()} className="delete-button">
                        <Trans>Delete</Trans>
                    </button>
                </div>
            </div>
        </div>
)}

export default WorkEntryDisplay;